import React from "react";
import { confirmationServiceContext as ConfirmationServiceContext } from "src";
import { ConfirmationOptions } from "src/components/controls/feedback/dialog";
 
/**
 *
 */
export const useConfirmationDialog = () =>
  React.useContext(ConfirmationServiceContext);
